import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=559e959b&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e959b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('559e959b')) {
      api.createRecord('559e959b', component.options)
    } else {
      api.reload('559e959b', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=559e959b&scoped=true&", function () {
      api.rerender('559e959b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l55eAOvIJ76E/JS/comp/Accordion.vue"
export default component.exports